"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeResponseDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Account_dto_1 = require("./Account.dto");
const UserMinimal_dto_1 = require("./UserMinimal.dto");
const enums_1 = require("../../enums");
const MapFilterConfigItem_dto_1 = require("./MapFilterConfigItem.dto");
const MapActionConfigItem_dto_1 = require("./MapActionConfigItem.dto");
const AppFeatureToggles_dto_1 = require("./AppFeatureToggles.dto");
class MeResponseDto {
  constructor() {
    this.unreadMessages = 0;
  }
}
exports.MeResponseDto = MeResponseDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: () => Account_dto_1.AccountDto
}), __metadata("design:type", Account_dto_1.AccountDto)], MeResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.IdentityProvider,
  isArray: true,
  description: 'Connected sign-in methods on this account (Google, Apple, Telephone).',
  example: [enums_1.IdentityProvider.Telephone, enums_1.IdentityProvider.Google]
}), __metadata("design:type", Array)], MeResponseDto.prototype, "identityProviders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => UserMinimal_dto_1.UserMinimalDto,
  nullable: true
}), __metadata("design:type", Object)], MeResponseDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.MapVersion,
  required: false
}), __metadata("design:type", String)], MeResponseDto.prototype, "mapVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueGroupingMode,
  required: false
}), __metadata("design:type", String)], MeResponseDto.prototype, "venueGroupingMode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => [MapFilterConfigItem_dto_1.MapFilterConfigItemDto],
  required: false
}), __metadata("design:type", Array)], MeResponseDto.prototype, "mapFilters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => [MapActionConfigItem_dto_1.MapActionConfigItemDto],
  required: false,
  description: 'New-map sidebar filters in display order (Feature Flags -> Map filters). Live changes arrive over the socket ' + 'as featureFlagUpdated (key = mapActions, payload = this array).'
}), __metadata("design:type", Array)], MeResponseDto.prototype, "mapActions", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => AppFeatureToggles_dto_1.AppFeatureTogglesDto,
  required: false,
  description: 'Feature Flags kill switches. Absent from older API responses — the client keeps its last known values then. ' + 'Live changes arrive over the socket as featureFlagUpdated (key = the FeatureFlagKey, payload = boolean).'
}), __metadata("design:type", AppFeatureToggles_dto_1.AppFeatureTogglesDto)], MeResponseDto.prototype, "features", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Minimum app version (major.minor.patch) the client must meet to use the system.',
  example: '1.4.0'
}), __metadata("design:type", String)], MeResponseDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], MeResponseDto.prototype, "warnOfRecentInactiveCheckout", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this account is allowed to check in remotely (outside venue geofence).',
  required: false
}), __metadata("design:type", Boolean)], MeResponseDto.prototype, "allowedRemoteCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether "near a My Place" proximity detection is currently live for this user (rollout mode + their own ' + 'myPlaceProximityAction combined). Absent from older API responses; the client should only arm/disarm its ' + 'geofences when this key is present, never on a missing value.',
  required: false
}), __metadata("design:type", Boolean)], MeResponseDto.prototype, "myPlacesProximityEnabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the Footprints (visit history) feature is enabled for this user. The client should disable the ' + "map's Footprints entry point when this is false. Absent from older API responses.",
  required: false
}), __metadata("design:type", Boolean)], MeResponseDto.prototype, "footprintsEnabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.FootprintsHistoryWindow,
  required: false,
  description: 'How far back the user currently sees their own visit history (Footprints list, "has visited" flag).'
}), __metadata("design:type", String)], MeResponseDto.prototype, "footprintsHistoryWindow", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], MeResponseDto.prototype, "unreadMessages", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], MeResponseDto.prototype, "futureUnviewedEventCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AdminPermission,
  isArray: true,
  required: false
}), __metadata("design:type", Array)], MeResponseDto.prototype, "permissions", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether visit plans are automatically synced to the user\'s connected Google Calendar. Absent from older API responses.',
  required: false
}), __metadata("design:type", Boolean)], MeResponseDto.prototype, "googleCalendarAutoSyncEnabled", void 0);
//# sourceMappingURL=MeResponse.dto.js.map